import { SVGProps, Ref, forwardRef } from 'react'
const SvgSkull = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18 15.13a6 6 0 1 0-12 0 4.89 4.89 0 0 0 3 4.63v2.12a.76.76 0 0 0 .75.75h4.5a.75.75 0 0 0 .75-.75v-2.12a4.88 4.88 0 0 0 3-4.63v0ZM12.01 22.63v-2.25"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.76 14.38a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M14.26 14.38a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.5 21.37h2.25a1.5 1.5 0 0 0 1.5-1.5v-17a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v17a1.5 1.5 0 0 0 1.5 1.5H4.5M.75 5.87h22.5"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSkull)
export default ForwardRef
